// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"23570c9a","488":"48261a86","847":"267f0307","954":"af27cd7b"}[chunkId] + ".chunk.js";
};